import wx from 'weixin-js-sdk'
import Cookies from 'js-cookie'
/**
 * 判断是否在微信端
 */
function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

/**
 *
 * @param {String} name
 * 获取url指定参数
 */
function GetQueryString(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

/**
 *
 * @param {String} name
 * 获取url指定参数
 */
function GetQueryStringUrl(name, url) {
  let pathUrl = url.split('?').length > 1 ? url.split('?')[1] : ''
  if (pathUrl) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let r = pathUrl.match(reg)
    if (r != null) return unescape(r[2])
    return null
  } else {
    return null
  }
}

/**
 * 获取时间戳后10位
 */
function getTimestamp() {
  return Math.round(new Date().getTime() / 1000)
}

/**
 * 获取随机字符串
 */
function getNonceStr() {
  return Math.random()
    .toString(36)
    .substr(2, 15)
}

function getParentUrl() {
  var url = null
  if (parent !== window) {
    try {
      url = parent.location.href
    } catch (e) {
      url = document.referrer
    }
  }
  return url
}

// 微信接口配置
async function wxConfigFn(url, jsApiList) {
  // 时间戳
  let timestamp = getTimestamp()
  // 随机字符串
  let nonceStr = getNonceStr()
  // 公众号id
  let appId = await $api.getAppId()
  if (appId) {
    let params = {
      nonceStr: nonceStr,
      timestamp: timestamp,
      url: url,
    }
    // 获取签名
    let signature = await $api.getJsAPISignature(params)
    console.log('拿到signature', signature)
    if (signature) {
      wx.config({
        debug: false,
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: jsApiList,
      })
    }
  }
}

/**
 * 获取当前路由
 */
function getPath() {
  let url = window.location.href
  if (url) {
    if (url.indexOf('?') != -1) {
      let str1 = url.split('?')
      let str2 = str1[0]
      let path = str2.split('.com')[1]
      return path
    } else {
      let path = url.split('.com')[1]
      return path
    }
  } else {
    return ''
  }
}
/**
 * 授权函数
 */
async function ToLogin() {
  let toUrl = window.location.href
  window.localStorage.setItem('toUrl', toUrl)
  let redirect_uri = encodeURIComponent(toUrl)
  // 获取登录授权地址
  let data = await $api.getAuthorizeUrl(redirect_uri)
  if (data) {
    Cookies.remove('token')
    console.log('跳转到微信授权地址')
    // 跳转到微信授权地址
    window.location.href = data
  }
}

export {
  isWeiXin,
  GetQueryString,
  getPath,
  ToLogin,
  wxConfigFn,
  GetQueryStringUrl,
  getParentUrl,
}
